import React from 'react';

export const Card = ({ className, children, ...props }) => (
  <div className={`bg-white dark:bg-gray-800 rounded-lg shadow-lg ${className}`} {...props}>
    {children}
  </div>
);

export const CardHeader = ({ className, children, ...props }) => (
  <div className={`px-4 py-5 sm:px-6 ${className}`} {...props}>
    {children}
  </div>
);

export const CardContent = ({ className, children, ...props }) => (
  <div className={`px-4 py-5 sm:p-6 ${className}`} {...props}>
    {children}
  </div>
);
